<template>
  <ValidationCard
    color="green lighten-2"
    :by="validatedBy"
    :date="validatedAt"
    :icon="icon"
    :title="$t('rev.status.impact_validated')"
  >
    <template v-slot:actions v-if="canDoFinancialValidation">
      <v-divider class="mx-6" />
      <v-card-actions class="d-flex justify-end px-6 py-3">
        <v-btn
          elevation="0"
          color="primary"
          rounded
          text
          @click="$emit('validate')"
        >
          {{ $t('rev.validation.edit_validation') }}</v-btn
        >
      </v-card-actions>
    </template>
  </ValidationCard>
</template>

<script>
import ValidationCard from './ValidationCard'

import { utils } from 'frontend-js-shared'
import mixin from '@/mixins/mixin.vue'

export default {
  name: 'RequestValidationCard',

  components: { ValidationCard },

  mixins: [mixin],

  props: ['rev', 'canDoFinancialValidation'],

  data() {
    return {
      icon: {
        name: 'mdi-check-decagram',
        color: 'green',
      },
    }
  },

  computed: {
    validatedAt() {
      const date =
        this.rev?.validations?.financial?.validatedAt ??
        this.rev?.validation?.financialValidatedAt
      return utils.dates.humanDate(date)
    },

    validatedBy() {
      return (
        this.rev?.validations?.financial?.auditor ??
        this.rev?.validation?.financialValidatedBy
      )
    },
  },
}
</script>
